import {Component, OnInit, Inject, Injectable, ChangeDetectorRef  } from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {DocumentMetadataService} from "../../../api/service/documentMetadata.service";
import {DocumentService} from "../../../api/service/document.service";
import {AwsService} from "../../../api/service/aws.service";
import {DocumentMetadata} from "../../../api/model/documentMetadata";
import {FilterDocumentMetadata} from "../../../api/model/filterDocumentMetadata";
import {MetadataDefinition} from "../../../api/model/metadataDefinition";
import {MetadataDefinitionService} from "../../../api/service/metadataDefinition.service";
import {MetadataDefinitionEnum} from "../../../api/model/metadataDefinitionEnum";
import { SharedService } from '../../service/shared.service';
import { NxMessageToastService } from '@aposin/ng-aquila/message';
import {DocumentUrl} from "../../../api/model/documentUrl";
import {Sorts} from "../../../api/model/sorts";
import {Sort} from "../../../api/model/sort";
import {SearchedDocuments} from "../../../api/model/searchedDocuments";
import { DatePipe } from '@angular/common';
import { InfoDialogService } from '../../../app/interceptors/modal/info-dialog.service';
import { ProgressDialogService } from '../../../app/interceptors/modal/progress-dialog.service';
import { TabsComponent } from '../../tabs/tabs.component';
import {
	NxSortHeaderIntl,
	SortDirection,
	SortEvent,
} from '@aposin/ng-aquila/table';
import { from, Observable, of, Subject, timer } from 'rxjs';
import { mergeMap, catchError, finalize, map, tap, concatMap } from 'rxjs/operators';

import {
	NX_TOOLTIP_DEFAULT_OPTIONS,
	NxTooltipDefaultOptions,
} from '@aposin/ng-aquila/tooltip';

import { JadeDocumentStatusEnum } from '../../../api/model/jadeDocumentStatusEnum';
import { log } from 'console';

// import { JadeDocumentStatusEnum } from 'src/api/model/jadeDocumentStatusEnum';

const myDefaultOptions: NxTooltipDefaultOptions = {
	position: 'right',
	showDelay: 500,
	hideDelay: 0,
	touchendHideDelay: 1500,
};

@Injectable()
export class MyIntl extends NxSortHeaderIntl {
	sortAscendingAriaLabel = 'sort ascending by';
	sortDescendingAriaLabel = 'sort descending by';
}

	// Define the structure of the stored object
interface DisplayState {
  marked: boolean;
  openItemDisplayed: boolean;
  versionsDisplayed: boolean;
  updateAttributeDisplayed: boolean;
  documentDisplayed: boolean;
  importDuplicateDisplayed: boolean;
  markedForBulkDownload: boolean;
}


@Component({
	selector: 'app-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.scss'],
	providers: [
		{ provide: NX_TOOLTIP_DEFAULT_OPTIONS, useValue: myDefaultOptions },
		{provide: NxSortHeaderIntl, useClass: MyIntl}
	],
})
export class ListComponent implements OnInit {
	readonly emailText: string = "mailto:?Subject=eAkte+ Suchergebnis&body=Bitte nutzen Sie die nachstehende Verknüpfung um die Dokumentensuche im EDM auszuführen:  %0D";
	readonly toastSearchSuccessText: string = 'Suchergebnis (Anzahl der gefundenen Dokumente: ';
	readonly toastSearchNoResultsText: string = 'Zu deiner Suche wurden keine passenden Dokumente gefunden.';
	// readonly acceptableFormatForDocument = 'text/plain, text/csv, image/tiff, image/bmp, image/jpeg, image/png, image/gif, ' +
    // 'application/msword, application/vnd.ms-powerpoint, application/vnd.ms-excel, application/vnd.ms-outlook, application/pdf, ' +
    // 'application/rtf, text/html, application/vnd.openxmlformats-officedocument.wordprocessingml.document, ' +
    // 'application/vnd.openxmlformats-officedocument.presentationml.presentation, ' +
    // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, message/rfc822';

	readonly mimeTypeIconMap: { [mimeType: string]: string } = {
		'application/pdf': 'application_pdf.gif',
		'application/msword': 'application_msword.gif',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'application_msword.gif',
		'application/rtf': 'application_msword.gif',
		'application/vnd.ms-excel': 'application_msexcel.gif',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'application_msexcel.gif',
		'text/csv': 'application_msexcel.gif',
		'application/vnd.ms-powerpoint': 'application_mspowerpoint.gif',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'application_mspowerpoint.gif',
		'application/vnd.ms-outlook': 'application_msoutlook.gif',
		'message/rfc822': 'application_msoutlook.gif',
		'application/vnd.ms-office': 'application_msoutlook.gif',
		'text/html': 'text_html.gif',
		'text/plain': 'text_plain.gif',
		'image/tiff': 'image_tiff.gif',
		'image/bmp': 'image_bmp.gif',
		'image/jpeg': 'image_jpeg.gif',
		'image/png': 'image_jpeg.gif',
		'image/gif': 'image_jpeg.gif',
	};
	readonly defaultDescriptiveIcon = 'text_plain.gif';

	cancel$ = new Subject<void>();
	tabTitle: string = 'Dokument Liste';
	loader = false;
	showVersionsFlag: boolean = true;
	page: number = 1;
	pageSize: number = 15;
	totalItems: number = 0;

	progress = 0;
	processedCount = 0;
	totalCount = 0;
	startTime = Date.now();

	filter: FilterDocumentMetadata = {};
	documents: DocumentMetadata[] = [];
	linkId?: string;
	currentPageDocuments: DocumentMetadata[] = [];

	documentCategoryData: any = {};
	documentTypeData: any = {};
	documentStatusData: any = {};
	confidentialityLevelData: any = {};
	documentProcessedData: any = {};
	dataProtectionData: any = {};
	countriesData: any = {};
	inOutFlagData: any = {};
	documentChannelData: any = {};
	deliverySystemData: any = {};

	displayStateMap: Map<string, DisplayState> = new Map();

	constructor(
    private readonly documentMetadata: DocumentMetadataService,
    private readonly documentService: DocumentService,
    private readonly oauthService: OAuthService,
    private readonly sharedService: SharedService,
    private readonly messageToastService: NxMessageToastService,
    private readonly metadataDefinitionService: MetadataDefinitionService,
    private readonly awsService: AwsService,
    private readonly datePipe: DatePipe,
	private infoDialogService: InfoDialogService,
	private progressDialogService: ProgressDialogService,
	private tabsComponent: TabsComponent,
	private cdr: ChangeDetectorRef
	) {}


	ngOnInit(): void {
	  this.documentService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
	  this.documentMetadata.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
	  this.metadataDefinitionService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		this.loader = true;

		this.loadData(MetadataDefinitionEnum.COUNTRY, this.countriesData);
		this.loadData(MetadataDefinitionEnum.DOCUMENTCATEGORY, this.documentCategoryData);
		this.loadData(MetadataDefinitionEnum.DOCUMENTTYPE, this.documentTypeData);
		this.loadData(MetadataDefinitionEnum.DOCUMENTSTATUS, this.documentStatusData);
		this.loadData(MetadataDefinitionEnum.DOCUMENTPROCESSED, this.documentProcessedData);
		this.loadData(MetadataDefinitionEnum.CONFIDENTIALITYLEVEL, this.confidentialityLevelData);
		this.loadData(MetadataDefinitionEnum.DATAPROTECTION, this.dataProtectionData);
		this.loadData(MetadataDefinitionEnum.INOUTFLAG, this.inOutFlagData);
		this.loadData(MetadataDefinitionEnum.DOCUMENTCHANNEL, this.documentChannelData);
		this.loadData(MetadataDefinitionEnum.DELIVERYSYSTEM, this.deliverySystemData);

	  if (!!this.linkId) {
	    this.documentMetadata.documentMetadatasGetSearchFilter(this.linkId).subscribe((filter: FilterDocumentMetadata) => {
	      this.filter = filter;		  
		  localStorage.removeItem('list');

		  this.setTabTitleOnTabs()
	      this.searchDocumentsBySearchCriteria();
			}, error => {
		      this.loader = false;		
			//   this.filter = {};
			//   this.filter.pagination = {};
			//   this.filter.sorts = {};	 
			//   this.documents = this.getTestData();
			//   this.totalItems = this.documents.length; 
			    throw error;
			  }
			);
	  } else if (this.documents.length === 0) {
			this.setTabTitleOnTabs()
			this.searchDocumentsBySearchCriteria();
	  } else {
			this.loader = false;
			this.setDescriptiveIcon();
			this.setTotalVersions();
	  }
	}

	loadData(metadataDefinitionEnum: MetadataDefinitionEnum, metadataDefinitiondData: any) {
		this.metadataDefinitionService.metadatadefinitionGet(metadataDefinitionEnum).subscribe((data: MetadataDefinition[]) => {
			data.forEach((item: MetadataDefinition) => {
   	    for (const [key, value] of Object.entries(item)) {
					metadataDefinitiondData[key] = value;
				}
			});
  	});
	}

	setTabTitleOnTabs() {
		//Vorgang ID
		const coverProcessIdFilter =  !!this.filter?.filterMetadata?.coverProcessId && String(this.filter?.filterMetadata?.coverProcessIdFilterOperation) === 'EQUAL';
		//Personennummer DN
		const policyHolderIdIdFilter =  !!this.filter?.filterMetadata?.policyHolderId && String(this.filter?.filterMetadata?.policyHolderIdFilterOperation) === 'EQUAL';
		//Personennummer AK
		const foreignCustomerIdFilter =  !!this.filter?.filterMetadata?.foreignCustomerId && String(this.filter?.filterMetadata?.foreignCustomerIdFilterOperation) === 'EQUAL';
		//APG Vertrag 
		const contractNumberFilter =  !!this.filter?.filterMetadata?.contractNumber && String(this.filter?.filterMetadata?.contractNumberFilterOperation) === 'EQUAL';
			
		const trueCount = [coverProcessIdFilter, policyHolderIdIdFilter, foreignCustomerIdFilter, contractNumberFilter].filter(Boolean).length;
		if (coverProcessIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'Vg.ID ' + this.filter.filterMetadata?.coverProcessId!.toString()!);	
		}else if (policyHolderIdIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'Pers.Nr.DN ' +this.filter.filterMetadata?.policyHolderId!.toString()!);	
		}else if (foreignCustomerIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'Pers.Nr.AK ' + this.filter.filterMetadata?.foreignCustomerId!.toString()!);	
		}else if (contractNumberFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'APG Vertrag ' + this.filter.filterMetadata?.contractNumber!.toString()!);	

		}
	}

	searchDocumentsBySearchCriteria() {
		this.addPagination();
		this.retrieveDocumentsFromSearchCriteria();
	}

	addPagination() {
		if (!this.filter.pagination) {
			this.filter.pagination = {};
			this.filter.sorts = {};
		}
	  this.filter.pagination.page = this.page;
	  this.filter.pagination.pageSize = this.pageSize;
	}

	retrieveDocumentsFromSearchCriteria() {
	  this.loader = true;
		this.documentMetadata.documentMetadatasList(this.filter).subscribe((data: SearchedDocuments) => {
		  var docs = data.documents;
			if(docs) {
			  this.toastSearchSuccess(data.totalItems);
			  this.documents = docs;
			  this.totalItems = data.totalItems;
			} else {
			  this.toastSearchNoResults();
			  this.modifySearch();
			}
			this.setDescriptiveIcon();
			this.setTotalVersions();
			this.loader = false;
		}, error => {
		      this.loader = false;
			    throw error;
			  }
		);
	}

	isAllMarkedForBulkDownload(): boolean {
		
		// console.log(new Date(), this.displayStateMap);
		if (this.documents.length === 0) {
		return false;
		}
		return this.documents.every(document => this.isMarkedForBulkDownload((document.dui || '')));
	}

	trackByDui(index: number, item: any) {
		return item.dui;
	}

	selectAllItems(): void {
	  const value = !this.isAllMarkedForBulkDownload();
	  this.loader = true;
	  const filterLocal = JSON.parse(JSON.stringify(this.filter));
	  filterLocal.pagination = { pageSize: 5000}
		this.documentMetadata.documentMetadatasList(filterLocal).subscribe((data: SearchedDocuments) => {
		    var docs = data.documents;
			if(docs) {
			//   this.toastSelectAllSuccess(docs.length);
			  for(const doc of docs){
				this.setMarkedForBulkDownload((doc.dui || ''), value);
			  }
			  this.cdr.detectChanges();
			} 			
			this.loader = false;
		}, error => {
		      this.loader = false;
			    throw error;
			  }
		);
	}

	setDescriptiveIcon() {
		this.documents.forEach((document: DocumentMetadata) => {
			const mimeType = document.documentMimeType ? document.documentMimeType.trim().toLowerCase() : '';
			document.descriptiveIconPath = this.mimeTypeIconMap[mimeType] || this.defaultDescriptiveIcon;
		});
	}

	setTotalVersions() {
		this.documents.forEach((document: DocumentMetadata) => {
			if (document.lastVersion === 'current') {
			  document.totalVersions = 1;
			} else {
			  document.totalVersions = Number(document.lastVersion) + 1;
			}
		});
	}

	onPageChange(page: number): void {
		this.page = page;
	  this.searchDocumentsBySearchCriteria();
	}

	openShowVersions(documentMetadata: DocumentMetadata): void {
		if (documentMetadata.dui) {
	      this.setVersionsDisplayed(documentMetadata.dui, true);
	    }
		
	  this.loader = true;
		this.documentMetadata.documentmetadataHistoryGet(documentMetadata.dui).subscribe((data: DocumentMetadata[]) => {
			if(data) {
			  this.sharedService.sendMessage('showVersions', data);
			}
			this.loader = false;
		}, error => {
		    this.loader = false;
			  throw error;
		}
		);
	}

	modifySearch() {
		this.sharedService.sendMessage('modifySearch', this.filter);
	}

	generateSearchLink() {
	  this.loader = true;
 		this.documentMetadata.documentMetadatasCreateSearchFilter(this.filter).subscribe((searchFilterId: string) => {
		  var encodedUrl = encodeURIComponent(window.location.href + "/list/" + searchFilterId);
		  window.location.href = this.emailText + encodedUrl;
		  this.loader = false;
		}, error => {
		      this.loader = false;
			    throw error;
			  }
		);
	}

	openDetails(documentMetadata: DocumentMetadata) : void {
		if (documentMetadata.dui) {
	      this.setUpdateAttributeDisplayed(documentMetadata.dui, true);
	    }
		this.sharedService.sendMessage('details', {documentMetadata: documentMetadata, filter: this.filter});
	}

	showTechnicalDetails(documentMetadata: DocumentMetadata, event: MouseEvent) : void {
		event.preventDefault(); // Prevent the default context menu
		let msg: string = "Technical details";
		let details: string = `${JSON.stringify(documentMetadata)}`
		var businessError = { message: msg, details, title: "Technical details:"};
		this.infoDialogService.openDialog(businessError);
	}

	// openDocument(documentMetadata: DocumentMetadata) : void {
	//   if (documentMetadata.dui) {
	//     this.setOpenItemDisplayed(documentMetadata.dui, true);
	//   }
	//   if (documentMetadata.jadeDocumentStatus !== "PROCESSING_FAILED") {
	//     this.loader = true;
	// 		this.documentService.documentGet(documentMetadata.dui).subscribe((documentUrl: DocumentUrl) => {
	// 			window.open(documentUrl.presignedUrl);
	// 			this.loader = false;
	// 		}, error => {
	// 	      this.loader = false;
	// 		    throw error;
	// 		  }
	// 		);
	//   } else{
	// 		let msg: string = "Der Upload der Datei wurde abgebrochen, da unser System potenziell gefährdende Inhalte erkannt hat. Bitte beachten Sie, dass es sich hierbei auch um eine falsche positive Erkennung handeln könnte. Empfohlene Schritte: 1. Überprüfen Sie die Datei: Stellen Sie sicher, dass die Datei keine schädlichen Inhalte enthält. 2. Kontaktieren Sie den eAkte+ Support: Wenn Sie sicher sind, dass die Datei sicher ist, wenden Sie sich bitte an den eAkte+ Support, um weitere Unterstützung zu erhalten.";			

	// 		try {
	// 			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
				
	// 			// Check if documentFailureReasonCode exists and is not null/undefined/empty
	// 			if (info && typeof info.documentFailureReasonCode !== 'undefined' && info.documentFailureReasonCode !== null) {
	// 				msg += ` ${info.documentFailureReasonCode.replace(/_/g, ' ')}.`;
	// 			}
	// 			if (info && typeof info.documentFailureReasonDescription !== 'undefined' && info.documentFailureReasonDescription !== null) {
	// 				msg += ` ${info.documentFailureReasonDescription}`;
	// 			}
	// 		} catch (error) {
	// 			//console.error('Invalid JSON in jadeDocumentInfo:', error);
	// 		}
	// 		let details: string = `${JSON.stringify(documentMetadata.jadeDocumentInfo)} ${JSON.stringify(documentMetadata.jadeDocumentError)}`
	// 		var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
	// 		this.infoDialogService.openDialog(businessError);
	// 	}
	// }

	openDocument(documentMetadata: DocumentMetadata) : void {	  			
	  if (documentMetadata.dui) {
		if (this.showVersionsFlag){
	      this.setOpenItemDisplayed(documentMetadata.dui+documentMetadata.version, true);
		}else{
		  this.setOpenItemDisplayed(documentMetadata.dui, true);
		}	    
	  }
	  if (String(documentMetadata.jadeDocumentStatus) !== 'PROCESSING_FAILED' && String(documentMetadata.jadeDocumentStatus) !== 'ABORTED') {
	    this.loader = true;
		this.documentService.documentGet(documentMetadata.dui).subscribe((documentUrl: DocumentUrl) => {
				window.open(documentUrl.presignedUrl);
				this.loader = false;
			}, error => {
		      this.loader = false;
			  let msg: string = "";
			  if ((this.hasJadeIsFileUploaded(documentMetadata) && !this.getJadeIsFileUploaded(documentMetadata)) ||
						String(documentMetadata.jadeDocumentStatus) === "FAILED_UPLOADING_TO_JADE" ||
						String(documentMetadata.jadeDocumentStatus) === "FAILED_UPLOADING_TO_JADE_RETRY"){
				msg = "Das Dokument kann nicht geöffnet/heruntergeladen werden, da bereits während des Uploadvorgangs technische Probleme aufgetreten sind. Bitte versuche den Upload der Datei erneut oder kontaktiere den Lade-User des Dokuments.";				
			  }
			  if (this.hasJadeDocumentFailureReasonCode(documentMetadata)){
				msg = ListComponent.getJadeErrorMessage(this.getJadeDocumentFailureReasonCode(documentMetadata));
				if (this.hasJadeDocumentFailureReasonDescription(documentMetadata)){
					msg += ` ${this.getJadeDocumentFailureReasonDescription(documentMetadata)}`;
				}				
			  }

			  if (msg !== ""){
				let details: string = `${JSON.stringify(documentMetadata.jadeDocumentInfo)} ${JSON.stringify(documentMetadata.jadeDocumentError)}`
				var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
				this.infoDialogService.openDialog(businessError);
				return;
			  }
			  throw error;
			  }
		);
		} else{
			this.loader = true;
			this.documentService.documentGet(documentMetadata.dui).subscribe((documentUrl: DocumentUrl) => {
					window.open(documentUrl.presignedUrl);
					this.loader = false;
				}, error => {
					this.loader = false;
					let msg: string = "Das Dokument kann nicht geöffnet/heruntergeladen werden, da bereits während des Uploadvorgangs technische Probleme aufgetreten sind. Bitte versuche den Upload der Datei erneut oder kontaktiere den Lade-User des Dokuments.";
					if (this.hasJadeIsFileUploaded(documentMetadata) && !this.getJadeIsFileUploaded(documentMetadata)){
						msg = "Das Dokument kann nicht geöffnet/heruntergeladen werden, da bereits während des Uploadvorgangs technische Probleme aufgetreten sind. Bitte versuche den Upload der Datei erneut oder kontaktiere den Lade-User des Dokuments.";				
					}
					if (this.hasJadeDocumentFailureReasonCode(documentMetadata)){
						msg = ListComponent.getJadeErrorMessage(this.getJadeDocumentFailureReasonCode(documentMetadata));
						if (this.hasJadeDocumentFailureReasonDescription(documentMetadata)){
							msg += ` ${this.getJadeDocumentFailureReasonDescription(documentMetadata)}`;
						}				
					}

					if (msg !== ""){
						let details: string = `${JSON.stringify(documentMetadata.jadeDocumentInfo)} ${JSON.stringify(documentMetadata.jadeDocumentError)}`
						var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
						this.infoDialogService.openDialog(businessError);				
					}
				}
			);	
		}
	}

	showBulkDownloadButton(): boolean {
		if (this.documents.length === 0) {
			return false;
		}
		return this.documents.some(document => this.isMarkedForBulkDownload((document.dui || '')));
	}

	bulkDownloadPrallel(): void {
		this.loader = true;

		// const ids = [...new Set(
		// 	[...this.displayStateMap]
		// 	.filter(([, state]) => state.markedForBulkDownload)
		// 	.map(([dui]) => dui)
		// )];

		const chunkSize = 100;
		const concurrency = 1;
		
		this.processedCount = 0;
		this.progress = 0;
		this.startTime = Date.now();
		
/////////////////////////////

		const markedArrayDuis = Array.from(this.displayStateMap.entries())
				.filter(([dui, displayState]) => displayState.markedForBulkDownload === true)
				.map(([dui]) => (dui))
		this.totalCount = markedArrayDuis.length;

		const filterLocall = JSON.parse(JSON.stringify(this.filter));
	    filterLocall.pagination = { pageSize: 5000}
		this.documentMetadata.documentMetadatasList(filterLocall).subscribe((data: SearchedDocuments) => {
		    var docs = data.documents;
			if(docs) {
				
			    const ids = [
					...new Set(
						docs.filter(document => markedArrayDuis.includes(document.dui || '') &&
							document.jadedui != null && document.jadedui !== '' && 
							!this.isDocumentWithError(document))
						  .map(document => document.jadedui +'')
					)
				];
				
				this.totalCount = ids.length;
				this.progressDialogService.openDialog({
					disableClose: true,
					data: {
						progress: 0,
						processed: 0,
						total: ids.length,
						speed: 0,
						eta: 0,
						failedItems: [],
						cancel: () => this.cancel$.next()
					}
				});
				const chunks: string[][] = [];
				for (let i = 0; i < ids.length; i += chunkSize) {
					chunks.push(ids.slice(i, i + chunkSize));
				}

				const failedItems: string[] = [];

				from(chunks).pipe(
					mergeMap(chunk => this.processChunk(chunk, failedItems), concurrency),
						finalize(() => {
							this.loader = false;	
							if (failedItems.length > 0) {
								this.downloadErrors(failedItems);
							}		
							let details: string = `${JSON.stringify(failedItems)}`
							var businessError = { message: 'List of failed bulk download items:', details, title: "Failed download items"};
							this.infoDialogService.openDialog(businessError);						
							console.log('Failed bulk download items:', failedItems);
						})
				).subscribe();
				
			} else{
				this.loader = false;					
			}
		}, error => {
		      this.loader = false;
			    throw error;
			  }
		);

		
	}

	// private updateProgress(count: number = 1) {
	// 	this.processedCount += count;
	// 	this.progress = Math.round((this.processedCount / this.totalCount) * 100);
	// }

	

	private updateProgress(count: number = 1) {
		this.processedCount += count;

		const now = Date.now();
		const elapsedSec = (now - this.startTime) / 1000;

		this.progress = Math.round((this.processedCount / this.totalCount) * 100);

		const speed = this.processedCount / elapsedSec;
		const remaining = this.totalCount - this.processedCount;
		const eta = speed > 0 ? Math.round(remaining / speed) : 0;

		this.progressDialogService.setProgress(this.progress, this.processedCount, this.totalCount, speed, eta);
	}

	private downloadErrors(failedItems: string[]) {
		const blob = new Blob([failedItems.join('\n')], { type: 'text/plain' });
		const url = window.URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = 'failed-items.txt';
		a.click();

		window.URL.revokeObjectURL(url);
	}

	private processChunk(chunk: string[], failedItems: string[]): Observable<null> {
		return this.processChunkRecursive(chunk, failedItems);
	}

	private processChunkRecursive(
		chunk: string[],
		failedItems: string[]
	): Observable<null> {
		const markedArray = chunk.join(',');

		type FilterDocumentMetadataBulk = FilterDocumentMetadata & {
					isBulkDownload: boolean;
					duis: Array<string>;
				};

		const filterLocal: FilterDocumentMetadataBulk = {
			isBulkDownload: true,
			duis: chunk,
		};

		return this.documentMetadata.documentMetadatasCreateSearchFilter(filterLocal).pipe(
			concatMap((presignedUrl: string) => {				

				if (!presignedUrl) {
					this.updateProgress(chunk.length);
					return of(null);
				}

				// mic delay între download-uri
				return timer(300).pipe(
					tap(() => {
						if (chunk.length > 1) {
							this.triggerDownload(presignedUrl);
						} else {
							window.open(presignedUrl);	
						}
						this.updateProgress(chunk.length);
					}),
					map(() => null)
				);
			}),

			catchError((err) => {
				// item final -> fail definitiv
				if (chunk.length === 1) {
					failedItems.push(`${chunk[0]} - ${err.message}`);
					this.updateProgress(1);

					return of(null);
				}

				// split în două jumătăți
				const middle = Math.ceil(chunk.length / 2);

				const leftChunk = chunk.slice(0, middle);
				const rightChunk = chunk.slice(middle);

				// serializăm și fallback-ul
				return from([leftChunk, rightChunk]).pipe(
					concatMap(subChunk =>
						this.processChunkRecursive(
							subChunk,
							failedItems
						)
					)
				);
			})
		);
	}

	private triggerDownload(url: string) {
		const link = document.createElement('a');
		link.href = url;
		link.download = '';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	bulkDownload() : void {	  			
	    // this.loader = true;
		
		// const markedArrayDuis = Array.from(this.displayStateMap.entries())
		// 		.filter(([dui, displayState]) => displayState.markedForBulkDownload === true)
		// 		.map(([dui]) => (dui))

		// const filterLocall = JSON.parse(JSON.stringify(this.filter));
	    // filterLocall.pagination = { pageSize: 10000}
		// this.documentMetadata.documentMetadatasList(filterLocall).subscribe((data: SearchedDocuments) => {
		//     var docs = data.documents;
		// 	if(docs) {
		// 	    const markedArray = [
		// 			...new Set(
		// 				docs.filter(document => markedArrayDuis.includes(document.dui || '') &&
		// 					document.jadedui != null && document.jadedui !== '' && 
		// 					!this.isDocumentWithError(document))
		// 				  .map(document => document.jadedui +'')
		// 			)
		// 		];
		// 		type FilterDocumentMetadataBulk = FilterDocumentMetadata & {
		// 			isBulkDownload: boolean;
		// 			duis: Array<string>;
		// 		};

		// 		const filterLocal: FilterDocumentMetadataBulk = {
		// 			isBulkDownload: true,
		// 			duis: markedArray,
		// 		};

		// 		this.documentMetadata.documentMetadatasCreateSearchFilter(filterLocal).subscribe((presignedUrl: string) => {		  
		// 			const link = document.createElement('a');
		// 			link.href = presignedUrl;
		// 			link.download = '';
		// 			document.body.appendChild(link);
		// 			link.click();
		// 			document.body.removeChild(link);
		// 			this.loader = false;
		// 		}, error => {
		// 			this.loader = false;
		// 				throw error;
		// 			}
		// 		);
		// 	} else{
		// 		this.loader = false;					
		// 	}
		// }, error => {
		//       this.loader = false;
		// 	    throw error;
		// 	  }
		// );
		this.bulkDownloadPrallel()
	}

	getRowClass(documentMetadata: DocumentMetadata): any {
		if (this.isMarked(this.showVersionsFlag?(documentMetadata.dui || '') + (documentMetadata.version || ''):documentMetadata?.dui)) {
			return { 'row-marked': true }; // Highlight for marked documents
		}
		if (this.isDocumentWithError(documentMetadata)) {
			return { 'row-with-error': true }; // Light red background for failed processing
		}
		return null; // No special style
	}

	isDocumentWithError(documentMetadata: DocumentMetadata): boolean {		
		const status = String(documentMetadata?.jadeDocumentStatus);			
		if (documentMetadata?.jadeDocumentStatus === JadeDocumentStatusEnum.PROCESSINGFAILED) {
			return true;
		} else if (status === 'ABORTED') {
			return true;
		}
		return false;
	}

	public static getJadeErrorMessage(documentFailureReasonCode: any): string {
		const errorMap: Record<string, string> = {
			"REJECTED_BY_SECURITY_MATRIX_MIME_TYPE_INVALID":
				"Der erkannte MIME-Typ der Datei ist nicht mit dem verwendeten Sicherheitsprofil kompatibel. / Der MIME Typ ist ungültig.",
			"SANITIZATION_FAILED_UNSUPPORTED_DOCUMENT":
				"Das Dokument konnte nicht hochgeladen werden, da es (oder einen Teil davon) nicht von unserem Anbieter unterstützt wird. Dies geschieht normalerweise bei sehr alten Versionen von Microsoft Word oder Excel (wie Office 95). Das Dokument muss in einer neueren Version gespeichert werden, um archiviert zu werden.",
			"SANITIZATION_FAILED_PASSWORD_PROTECTED_DOCUMENT":
				"Das Dokument konnte nicht hochgeladen werden, da es (oder einen Teil davon) passwortgeschützt ist. Das Passwort muss entfernt werden, damit das Dokument archiviert werden kann.",
			"SANITIZATION_FAILED_PROVIDER_INTERNAL_ERROR":
				"Auf der Seite unseres Sicherheitsanbieters ist ein technischer Fehler während des Sanitization Prozesses aufgetreten.",
			"SANITIZATION_FAILED":
				"Das Dokument konnte aus einem anderen Grund als vorhandener Passwortschutz oder nicht unterstütztes Dateiformat nicht hochgeladen werden. Der externe Sicherheitsanbieter konnte die Datei nicht bereinigen (sanitization). Bitte überprüfen Sie die “documentFailureReasonDescription” für weitere Details.",
			"FILE_TOO_BIG":
				"Das Dokument ist größer als 20 MB (Die maximal zulässige Größe hängt vom Sicherheitsprofilcode ab).",
			"EMPTY_FILE":
				"Die gesendete Datei ist leer (0 Bytes). Kein erneuter Versuch erforderlich.",
			"AV_TIME_OUT":
				"Zeitüberschreitung, bitte Upload erneut versuchen.",
			"AV_RISK_DETECTED":
				"Der externe Sicherheitsanbieter hat die Datei als unsicher markiert (z.B. einen Virus entdeckt), sie kann aus Sicherheitsgründen nicht hochgeladen werden.",
			"ABORTED_AV_LIMIT_REACHED":
				"Das von dem externen Anbieter (OPSWAT) erlaubte Antivirus-Kontingent wurde erreicht.",
			"DECLINED_BY_SECURITY_RULES":
				"Das Dokument wurde von der Sicherheits-API abgelehnt, was beispielsweise passiert, wenn der Dateityp im Profilcode nicht erlaubt ist.",
			"JADE_INTERNAL_ERROR":
				"Der Server hat ein unerwartetes Problem festgestellt, bitte den Upload erneut versuchen."
		};

		const defaultMessage = "Der Upload der Datei wurde abgebrochen. Eventuell könnte die Datei potenziell gefährdende Inhalte enthalten. Es könnte sich hierbei jedoch auch um eine falsch positive Erkennung handeln. Empfohlene Schritte: 1. Überprüfen Sie die Datei: Stellen Sie sicher, dass die Datei keine schädlichen oder andere potentiell gefährdende Inhalte (wie z.B. XML, Makros, Verschlüsselung etc.) enthält. 2. Kontaktieren Sie den eAkte+ Support um weitere Unterstützung zu erhalten.";
		
		
		// Handle null, undefined, or empty input safely
		if (!documentFailureReasonCode || typeof documentFailureReasonCode !== "string" || documentFailureReasonCode.trim() === "") {
			return defaultMessage;
		}

		// Normalize input (spaces, slashes → underscores)
		const normalizedCode = documentFailureReasonCode.trim().toUpperCase().replace(/[\/\s]+/g, "_");

		// Try to find a key that starts with the normalized code
		const matchedKey = Object.keys(errorMap).find(key =>
			normalizedCode.startsWith(key)
		);

		return matchedKey ? errorMap[matchedKey] : defaultMessage;
	}

	hasJadeDocumentFailureReasonCode(documentMetadata: DocumentMetadata): boolean {
		try {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.documentFailureReasonCode !== 'undefined' && info.documentFailureReasonCode !== null;
		} catch (error) {
			return false;
		}
	}

	getJadeDocumentFailureReasonCode(documentMetadata: DocumentMetadata): string {
		if (this.hasJadeDocumentFailureReasonCode(documentMetadata)) {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info.documentFailureReasonCode;
		}
		return "";
	}

	hasJadeIsFileUploaded(documentMetadata: DocumentMetadata): boolean {
		try {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.isFileUploaded !== 'undefined' && info.isFileUploaded !== null;
		} catch (error) {
			return false;
		}
	}

	getJadeIsFileUploaded(documentMetadata: DocumentMetadata): boolean {
		if (this.hasJadeIsFileUploaded(documentMetadata)) {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info.isFileUploaded;
		}
		return true;
	}


	getJadeDocumentFailureReasonDescription(documentMetadata: DocumentMetadata): string {
		if (this.hasJadeDocumentFailureReasonDescription(documentMetadata)) {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info.documentFailureReasonDescription;
		}
		return "";
	}

	hasJadeDocumentFailureReasonDescription(documentMetadata: DocumentMetadata): boolean {
		try {
			const info = JSON.parse(documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.documentFailureReasonDescription !== 'undefined' && info.documentFailureReasonDescription !== null;
		} catch (error) {
			return false;
		}
	}

	importDuplicate(documentMetadata: DocumentMetadata) : void {
		if (documentMetadata.dui) {
	      this.setImportDuplicateDisplayed(documentMetadata.dui, true);
	    }
		this.sharedService.sendMessage('importDuplicate', documentMetadata);
	}

	toastSearchSuccess(resultLength: number) {
	  const successText: string = this.toastSearchSuccessText + resultLength + ")";
		this.messageToastService.open(successText, {
			context: 'success',
			duration: 5000,
		});
	}

	toastSelectAllSuccess(resultLength: number) {
	  const successText: string = this.toastSearchSuccessText + resultLength + ")";
		this.messageToastService.open(successText, {
			context: 'success',
			duration: 5000,
		});
	}

	toastSearchNoResults() {
		this.messageToastService.open(this.toastSearchNoResultsText, {
			context: 'info',
			duration: 5000,
		});
	}

	sortTable(sortEvent: SortEvent) {
	  console.log(sortEvent);
	  console.log(this.filter.sorts);
	  var orderTypeCode;
	  if (this.filter.sorts && this.filter.sorts.sorts) {
	    this.filter.sorts.sorts.forEach(sort => {
	      if (sort.attributeName === sortEvent.active) {
	        if (sort.orderTypeCode === 'ASC') {
	          orderTypeCode = 'DESC';
	        } else {
	          orderTypeCode = 'ASC';
	        }
	      }
	    });
	  }

	  if (!orderTypeCode) {
	    orderTypeCode = sortEvent.direction.toUpperCase();
	  }
	  var sort: Sort = {
	    attributeName: sortEvent.active,
	    orderTypeCode: orderTypeCode
	  };
	  this.filter.sorts = {};
	  this.filter.sorts.sorts = [sort];
	  this.searchDocumentsBySearchCriteria();
	}

	formatDate(dateValue: any): string {
		if (!dateValue) {
			return dateValue;
		}
		if (typeof dateValue === 'string') {
			const date = this.parseDate(dateValue);
			if (date) {
				return this.datePipe.transform(date, 'dd/MM/yyyy') || dateValue;
			} else {
				return dateValue;
			}
		}
		return dateValue;
	}

	private parseDate(dateString: string): Date | null {
		const parts = dateString.split('-');
		const year = parseInt(parts[0]);
		const month = parseInt(parts[1]) - 1;
		const day = parseInt(parts[2]);
		const date = new Date(year, month, day);
		return isNaN(date.getTime()) ? null : date;
	}


  /** Returns the DisplayState for a given item, creating a default one if needed */
  private getOrCreateState(itemId?: string): DisplayState {
	if (!itemId) return {
        marked: false,
        openItemDisplayed: false,
        versionsDisplayed: false,
        updateAttributeDisplayed: false,
        documentDisplayed: false,
		importDuplicateDisplayed: false,
		markedForBulkDownload: false
      };
    if (!this.displayStateMap.has(itemId)) {
      this.displayStateMap.set(itemId, {
        marked: false,
        openItemDisplayed: false,
        versionsDisplayed: false,
        updateAttributeDisplayed: false,
        documentDisplayed: false,
		importDuplicateDisplayed: false,
		markedForBulkDownload: false
      });
    }
    return this.displayStateMap.get(itemId)!;
  }

  // --- MARKED ---
  isMarked(itemId?: string): boolean {
    return this.getOrCreateState(itemId).marked;
  }

  setMarked(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.marked = value;
  }

  toggleMarked(itemId?: string): void {
    const state = this.getOrCreateState(itemId);
    state.marked = !state.marked;
  }

  // --- OPEN ITEM DISPLAYED ---
  isOpenItemDisplayed(itemId?: string): boolean {
    return this.getOrCreateState(itemId).openItemDisplayed;
  }

  setOpenItemDisplayed(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.openItemDisplayed = value;
  }  

  // --- VERSIONS DISPLAYED ---
  isVersionsDisplayed(itemId?: string): boolean {
    return this.getOrCreateState(itemId).versionsDisplayed;
  }

  setVersionsDisplayed(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.versionsDisplayed = value;
  }

  // --- UPDATE ATTRIBUTE DISPLAYED ---
  isUpdateAttributeDisplayed(itemId?: string): boolean {
    return this.getOrCreateState(itemId).updateAttributeDisplayed;
  }

  setUpdateAttributeDisplayed(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.updateAttributeDisplayed = value;
  }

  // --- DOCUMENT DISPLAYED ---
  isDocumentDisplayed(itemId?: string): boolean {
    return this.getOrCreateState(itemId).documentDisplayed;
  }

  setDocumentDisplayed(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.documentDisplayed = value;
  }

  isImportDuplicateDisplayed(itemId?: string): boolean {
    return this.getOrCreateState(itemId).importDuplicateDisplayed;
  }

  setImportDuplicateDisplayed(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
    state.importDuplicateDisplayed = value;
  }

  toggleBulkDownload(itemId?: string): void {
    const state = this.getOrCreateState(itemId);
    state.markedForBulkDownload = !state.markedForBulkDownload;
  }

  isMarkedForBulkDownload(itemId?: string): boolean {
    return this.getOrCreateState(itemId).markedForBulkDownload;
  }

  setMarkedForBulkDownload(itemId: string, value: boolean): void {
    const state = this.getOrCreateState(itemId);
	state.markedForBulkDownload = value;
  }

  // --- RESET ALL ---
  resetState(itemId?: string): void {
	if (!itemId) return;
    this.displayStateMap.set(itemId, {
      marked: false,
      openItemDisplayed: false,
      versionsDisplayed: false,
      updateAttributeDisplayed: false,
      documentDisplayed: false,
	  importDuplicateDisplayed: false,
	  markedForBulkDownload: false
    });
  }


  
// Helper function for random strings/dates
 randomId(prefix: string): string {
  return prefix + Math.floor(Math.random() * 100000).toString().padStart(5, '0');
}

 randomDate(start = new Date(2020, 0, 1), end = new Date()): string {
  const d = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  return d.toISOString().split('T')[0];
}

 randomFrom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

//  getTestData() : DocumentMetadata[] {
// 	const mimeTypes = ['application/pdf', 'image/png', 'text/plain', 'application/msword'];
// 	const countries = ['DE', 'FR', 'IT', 'ES', 'PL', 'US', 'CN', 'IN', 'BR', 'ZA'];
// 	const categories = ['Invoice', 'Policy', 'Report', 'Email', 'Statement'];
// 	const statuses = ['ACTIVE', 'ARCHIVED', 'PENDING', 'VALIDATED', 'ERROR'];
// 	const users = ['system', 'admin', 'auditor', 'importTool', 'user1', 'user2'];
// 	const channels = ['EMAIL', 'PORTAL', 'API', 'MANUAL'];
// 	const flags = ['IN', 'OUT'];

// 	return  Array.from({ length: Math.floor(Math.random() * (100 - 50 + 1)) + 50 }, (_, i) => {
// 	const id = this.randomId('DOC');
// 	return {
// 		dui: id,
// 		edmId: this.randomId('EDM'),
// 		originalId: this.randomId('ORG'),
// 		s3Path: `s3://bucket/${id}.pdf`,
// 		documentDate: this.randomDate(),
// 		documentCategory: this.randomFrom(categories),
// 		documentType: this.randomFrom(['INVOICE', 'POLICY', 'REPORT', 'EMAIL']),
// 		documentTitle: `Document ${i + 1}`,
// 		documentNotes: Math.random() > 0.8 ? 'Requires review' : '',
// 		documentMimeType: this.randomFrom(mimeTypes),
// 		documentStatus: this.randomFrom(statuses),
// 		documentStatusTimestamp: new Date(),
// 		documentProcessed: this.randomFrom(['YES', 'NO']),
// 		confidentialityLevel: this.randomFrom(['LOW', 'MEDIUM', 'HIGH']),
// 		dataProtection: this.randomFrom(['STANDARD', 'SENSITIVE']),
// 		country: this.randomFrom(countries),
// 		invoiceNumber: `INV-${1000 + i}`,
// 		inOutFlag: this.randomFrom(flags),
// 		documentChannel: this.randomFrom(channels),
// 		documentPagesNo: Math.floor(Math.random() * 20) + 1,
// 		retentionDate: this.randomDate(new Date(2025, 0, 1), new Date(2030, 0, 1)),
// 		jobId: this.randomId('JOB'),
// 		loadDate: this.randomDate(),
// 		loadUser: this.randomFrom(users),
// 		changeUser: this.randomFrom(users),
// 		createdBy: this.randomFrom(users),
// 		modifiedBy: this.randomFrom(users),
// 		documentError: Math.random() > 0.95 ? 'Checksum mismatch' : '',
// 		deliverySystem: this.randomFrom(['JADE', 'ENCORES', 'GAUDIT', 'IMPORT_TOOL']),
// 		policyHolderId: this.randomId('PH'),
// 		contractNumber: `CN-${Math.floor(Math.random() * 9000 + 1000)}`,
// 		createdAtDateTime: new Date(),
// 		modifiedAtDateTime: new Date(),
// 		version: `v${Math.floor(Math.random() * 5) + 1}`,
// 		lastVersion: 'v5',
// 		totalVersions: Math.floor(Math.random() * 5) + 1,
// 		descriptiveIconPath: this.randomFrom([
// 		'icons/pdf_icon.gif',
// 		'icons/doc_icon.gif',
// 		'icons/image_icon.gif'
// 		]),
// 		jadeDocumentStatus: this.randomFrom([
// 		JadeDocumentStatusEnum.PROCESSINGFAILED,
// 		JadeDocumentStatusEnum.UPLOADED,
// 		JadeDocumentStatusEnum.PROCESSINGFINISHED
// 		]),
// 		jadeDocumentInfo: 'Auto-generated test document'
// 	};
// 	});

// 	}

}
